import styled from 'styled-components';
export var EditionButtons = styled.div.withConfig({
  displayName: "EditionButtons",
  componentId: "sc-eqh4eb-0"
})(["transform:translateX(32px);"]);